import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../../../locales/en/translation.json";
import es from "../../../locales/es/translation.json";
import { useEffect, useState } from "react";

export const useTranslations = () => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    i18next
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        detection: {
          caches: []
        },
        resources: {
          en: {
            translation: en
          },
          es: {
            translation: es
          }
        },
        fallbackLng: "en",
        // Keys are plain-English sentences; disable separators so "." and ":"
        // in a string are literal. Must match i18next-parser.config.js.
        keySeparator: false,
        nsSeparator: false,
        interpolation: {
          escapeValue: false
        }
      })
      .then(() => {
        setInitialized(true);
      });
  }, []);

  return initialized;
};
